import {baseApiInstanceWithRefresh} from "./baseApiInstance";
import {FAVORITES_URL} from "./urls";

export const getFavorites = () =>
    baseApiInstanceWithRefresh.get(FAVORITES_URL).then(r => r.data);

export const postFavorite = (slideId) =>
    baseApiInstanceWithRefresh.post(FAVORITES_URL, {slide_id: slideId}).then(r => r.data);

export const deleteFavorite = (slideId) =>
    baseApiInstanceWithRefresh.delete(`${FAVORITES_URL}${slideId}/`).then(r => r.data);
